import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyFormsIllustration = lazy(() => import('./svg-components/forms-illustration'));

const FormsIllustration = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyFormsIllustration {...rest} />
  </Suspense>
);

export default FormsIllustration;
